var _defs, _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path2, _line, _path3, _path4, _line2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon, _g2, _polygon2, _rect13, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polyline, _path35, _path36, _line3, _path37;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMercurioEmptyStateRecolecciones = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 288,
    viewBox: "0 0 346 288",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323,45.69c-17.75-20.1-46.24-27-73-28.15-10.85-.46-21.94-.15-32.25,3.29-13.1,4.38-23.73,13.32-34.42,22.3-14.21-9-32.46-14.41-52.37-14.41-45.36,0-82.14,28.09-82.14,62.75a49.29,49.29,0,0,0,.87,9.12c-1.28.84-2.56,1.7-3.81,2.61a98.89,98.89,0,0,0-22.59,23.37c-25,35.77-26.92,85.33-7.86,124.56a136.75,136.75,0,0,0,22.28,32.58H284.27c22.15-22.43,37.54-51.12,47.09-81.8a281.83,281.83,0,0,0,12.31-78.58C344.1,95.9,341.09,66.24,323,45.69Z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323,45.18c-17.75-20.1-46.24-27-73-28.14-10.85-.47-21.94-.16-32.25,3.29-20.8,7-35.39,25.4-53.84,37.27-35.64,22.89-83.78,20.18-118,45.1a98.7,98.7,0,0,0-22.59,23.37c-25,35.77-26.92,85.32-7.86,124.56A136.9,136.9,0,0,0,37.68,283.2H284.27c22.15-22.42,37.54-51.11,47.09-81.8a281.72,281.72,0,0,0,12.31-78.58C344.1,95.4,341.09,65.74,323,45.18Z",
    fill: "#d1f4e7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,259.31h92.2l1.31-66.19a9.51,9.51,0,0,0-.55-3.38l-19-54a10.9,10.9,0,0,0-10.39-7H346Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.66,257.76c0,14.54-11.46,26.33-25.61,26.33s-25.61-11.79-25.61-26.33,11.47-26.34,25.61-26.34S182.66,243.21,182.66,257.76Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,52.25h230.2a24.84,24.84,0,0,1,24.84,24.84V197.8a24.85,24.85,0,0,1-24.85,24.85H100A24.85,24.85,0,0,1,75.2,197.8V77.09A24.84,24.84,0,0,1,100,52.25Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,215.69a.56.56,0,0,1-.53-.57V63.54a.55.55,0,0,1,.53-.57H215V215.69Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,98c-.29,0-.53-.06-.53-.13V63.1c0-.08.24-.13.53-.13H215V98Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.55,52.25H222v170.4h125.6a7.55,7.55,0,0,0,7.54-7.54V59.79A7.54,7.54,0,0,0,347.55,52.25Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,222.65H344.64a7.53,7.53,0,0,1,7.53,7.53v21.61a7.52,7.52,0,0,1-7.52,7.52H93.41a0,0,0,0,1,0,0V222.65A0,0,0,0,1,93.41,222.65Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.28,226.77H348.69a11.82,11.82,0,0,1,1.47.11,10.32,10.32,0,0,0-8.34-4.23H93.41v36.66h6.87Z",
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,90.38h11.32a2.91,2.91,0,0,1-2.91,2.91h-5.5a2.91,2.91,0,0,1-2.91-2.91Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.93,
    cy: 258.17,
    r: 26.75,
    transform: "translate(-52.84 62.49) rotate(-13.28)",
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,257c0,15.4-11.46,27.88-25.61,27.88S223.05,272.44,223.05,257s11.47-27.89,25.61-27.89S274.27,241.64,274.27,257Z",
    fill: "#262626",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.25,257c0,7.57-5.63,13.71-12.59,13.71s-12.59-6.14-12.59-13.71,5.64-13.72,12.59-13.72S261.25,249.46,261.25,257Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.92,126.17h0a20.75,20.75,0,0,0-41.5,0,21.28,21.28,0,0,0,.25,3.21c.65,14,19.94,35.23,19.94,35.23C306.5,138.89,305,126.39,304.92,126.17Zm-20.73,9.3a8.85,8.85,0,1,1,8.84-8.85A8.85,8.85,0,0,1,284.19,135.47Z",
    fill: "#34806b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.79 63.52 93.85 68.08 92.71 63.52 214.79 63.52",
    fill: "#262626"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.29,
    y: 244.99,
    width: 77.17,
    height: 38.15,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170.56,
    y: 251.46,
    width: 15.04,
    height: 7.68,
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 227.68,
    y: 244.96,
    width: 15.78,
    height: 38.15,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.51,
    y: 225.48,
    width: 38.15,
    height: 77.17,
    transform: "translate(-136.69 391.23) rotate(-89.91)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 256.22,
    width: 38.15,
    height: 15.78,
    transform: "translate(-106.09 421.97) rotate(-89.91)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.69,
    y: 187.2,
    width: 38.15,
    height: 77.17,
    transform: "translate(-89.9 361.08) rotate(-89.63)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106.19,
    y: 209.3,
    width: 7.68,
    height: 15.04,
    transform: "translate(-107.52 325.41) rotate(-89.62)",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148.38,
    y: 218.08,
    width: 38.15,
    height: 15.78,
    transform: "translate(-59.6 391.97) rotate(-89.63)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 191.81,
    y: 187.56,
    width: 38.15,
    height: 77.17,
    transform: "translate(-16.63 435.55) rotate(-89.63)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 180.31,
    y: 209.67,
    width: 7.68,
    height: 15.04,
    transform: "translate(-34.26 399.89) rotate(-89.62)",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 218.45,
    width: 38.15,
    height: 15.78,
    transform: "translate(13.68 466.44) rotate(-89.63)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 147.25,
    y: 148.82,
    width: 38.15,
    height: 77.17,
    transform: "translate(-22.15 352.51) rotate(-89.63)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 170.93,
    width: 7.68,
    height: 15.04,
    transform: "translate(-39.78 316.85) rotate(-89.62)",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 177.95,
    y: 179.71,
    width: 38.15,
    height: 15.78,
    transform: "translate(8.15 383.4) rotate(-89.63)",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.74,267.57l.05,15.63,25.79-.08a6.1,6.1,0,0,0-.68-1.23c-1.32-1.94-4.9-5.5-13.41-5.76,0,0-7.85-10.13-5.91-15.61Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 112.78,
    y1: 281.64,
    x2: 137.79,
    y2: 281.56,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119,276a2.15,2.15,0,1,1-2.16-2.14A2.16,2.16,0,0,1,119,276Z",
    fill: "#00ffc7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.05,267.57l0,15.63,25.79-.08a5.69,5.69,0,0,0-.67-1.23c-1.33-1.94-4.91-5.5-13.42-5.76,0,0-7.84-10.13-5.91-15.61Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 79.1,
    y1: 281.64,
    x2: 104.11,
    y2: 281.56,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.33,276a2.15,2.15,0,1,1-2.15-2.14A2.14,2.14,0,0,1,85.33,276Z",
    fill: "#00ffc7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.61,267.61l28.52,1.14,3.42-60.47-2.68-35.68-1.42-18.87-23.28-5.91L72.75,149c-1.81,2.94-3.07,16.77-3.65,20.18-.42,2.6,1.06,11.24,1.62,13.44l5,19.8Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.24,84.22l25.21-.54c.73,12.13,4.33,21.8,8.51,31.74,1.07,2.53,2.38,4.91,3.23,7.55a13.31,13.31,0,0,1,.26,8.29c-2.17-.49-6.68.84-8.87.34l-.18-2.47a3.56,3.56,0,0,1-1.49,2.61,6,6,0,0,1-3.36.76,78.88,78.88,0,0,1-19.94-2.41c-.87-.23-6,1.47-6,1.47C68.2,119.35,71.17,97.86,74.24,84.22Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74,85.63c.78-4.19,1.56-8.56,4.88-11.24,3-2.39,6.37-3.11,10.14-3a13.23,13.23,0,0,1,5.64,1.77c2.25,1.22,3.24,3.77,4.35,6.08,2.23,4.63,2.06,11,.62,12.72l-19.32,10.6c-3.48-1.74-5.79-2.54-6.77-6.3C72.88,93.69,73.5,88.23,74,85.63Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.94,135.65c-.61,1,1.36,2,2.5,2.46a10.77,10.77,0,0,0,3.61.46,10.49,10.49,0,0,0,4.73-.78,7.51,7.51,0,0,0,3-3,21.82,21.82,0,0,0,1.66-4S69.63,131,66.94,135.65Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.94,135.65c-.61,1,1.36,2,2.5,2.46a10.77,10.77,0,0,0,3.61.46,10.49,10.49,0,0,0,4.73-.78,7.51,7.51,0,0,0,3-3,21.82,21.82,0,0,0,1.66-4S69.63,131,66.94,135.65Z",
    fill: "#262626"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M103.15,134.22a12.22,12.22,0,0,0,7.07,2.66,5.1,5.1,0,0,0,3.49-.89c.43-.36.77-.83,1.22-1.17s.66-.4.95-.65a1.19,1.19,0,0,0,.45-1,2.1,2.1,0,0,0-.68-1.23,9.33,9.33,0,0,0-4.85-1,16.85,16.85,0,0,0-5,.69,5.73,5.73,0,0,0-3.47,2.08",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.33,133.17a2.26,2.26,0,0,0-.9-1.14,8.68,8.68,0,0,0-4.63-1.13,16.85,16.85,0,0,0-5,.69,5.73,5.73,0,0,0-3.47,2.08l.81.55a12.22,12.22,0,0,0,7.07,2.66,5.1,5.1,0,0,0,3.49-.89c.43-.36.77-.83,1.22-1.17s.66-.4.95-.65A1.19,1.19,0,0,0,116.33,133.17Z",
    fill: "#262626"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.16,152.19,104,154.06a.35.35,0,0,0,.37-.34.34.34,0,0,0,0-.1l-2.6-10s.74-4.9,1.71-10.77c1.48-8.93,3.42-20.16,3.43-20.12-1.55-5.27-12.36-6.75-12.36-6.75l-12.42,0-.39-.75-3.65,1.45a16.51,16.51,0,0,0-2.31,1.14c-2.44,1.44-8.31,4.73-9.57,8.7-2.91,9.17.55,19.79.55,19.79l2.72-1.89a17.65,17.65,0,0,1,2.14-1.26l4.43,14.26a2.49,2.49,0,0,0-1.24,1.73,2.77,2.77,0,0,0,2.32,3",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.91,134.18s3.36-3.36,12.22-2.93a4.32,4.32,0,0,1,3.2,1.92l-.68-1.82c-1.92-5.07-9.15-19.85-9.15-19.85",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.18,143.84s13.32,1.52,21.22,2c6.11.4,8.93-1.07,10.37-4.94,1.21-3.24-.64-9.69-.64-9.69a20.31,20.31,0,0,0-9.45,1.31l.54,2.94-21.65.64Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.54,138.84a11,11,0,0,0-1.9-2.12,10.66,10.66,0,0,0-2.54-1.29",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.52,155.6c-.07,0-.21-.18-.3-.46s-.11-.55,0-.55.21.19.3.47S88.59,155.58,88.52,155.6Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1,93.22c2.2-.45,3.93-.07,6.05.18.51.06,2.51-.09,3.08-.08l.16-.24a2,2,0,0,0,0,.25s0,0,0,0c-.46,4-1,9.5,2.67,11.86-7.94,8.42-12.28,2.58-14-.32C83.73,99.75,85.06,98.68,84.1,93.22Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92,100.79l-8.85.91s1.12-3.21,2.14-4.12C86.56,96.44,86.87,101.2,92,100.79Z",
    fill: "#262626"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.48,81.92c.9,5.39,3.7,14.75-2.8,17.89-7.05,3.42-13.92-4.72-15.76-10.72-2-6.37,0-13,7.55-13.41,3.94-.22,10.87,1.21,11,6.33",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.66,74.23a11.25,11.25,0,0,1-.18,6.09,4.15,4.15,0,0,1-.78,1.52,1.85,1.85,0,0,1-1.52.66,6.77,6.77,0,0,0,1-4,14.8,14.8,0,0,1-1.8,4.3,5.09,5.09,0,0,1-3.85,2.34V84a3.61,3.61,0,0,1-1,2.06,1.85,1.85,0,0,1-2.15.29c.25-2.58-1.58-5.15-.87-7.63a6.22,6.22,0,0,1,3.75-3.62,14.29,14.29,0,0,1,7.39-1.08",
    fill: "#262626"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.48,74.4l.3-.16c.9-.58,1.46-1.21,3.07-.06a9.2,9.2,0,0,1,2.34,2.63,12,12,0,0,1,1.44,3,13.61,13.61,0,0,1,.52,3.86,4.45,4.45,0,0,1-1.84-2.4,13.2,13.2,0,0,0-1.24-2.82,7.76,7.76,0,0,1,.42,2.53,1.1,1.1,0,0,1-.21.66.46.46,0,0,1-.62.09,5.63,5.63,0,0,0-.33-3,15.78,15.78,0,0,0-1.45-2.72,15.33,15.33,0,0,1,.36,5.14,1.34,1.34,0,0,1-.22.7,1.18,1.18,0,0,1-1,.33,2.56,2.56,0,0,0-1.1.07A14.52,14.52,0,0,0,90.48,74.4Z",
    fill: "#262626"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.72,80.6c1.44,3.6-1.13,7.59-.65,11.42.34,2.76,2.25,5.24,2.13,8s-1,5.7-.76,8.5c.17,1.74,0,2.83.81,4.36a16.88,16.88,0,0,1,1.66,11.43l-8.84-.26a17.81,17.81,0,0,0-1.3-8.92c-.75-1.8-1.82-3.52-2-5.45s.54-3.54.81-5.31c.47-3.2-.4-6.43-.9-9.65s2-13.5,4-16",
    fill: "#262626"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.37,76a7.17,7.17,0,0,0-4.9-2.22A19.33,19.33,0,0,0,76.33,84.36a25.2,25.2,0,0,1-1-5.12c0-1.19.71-8.29,8-10.53C83.36,68.74,94.36,64.51,98.37,76Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77,82.8a29,29,0,0,1,9-8.59,55.17,55.17,0,0,1,13.41-5.46,8.75,8.75,0,0,1,3.7-.38,3.35,3.35,0,0,1,2.75,2.26c.38,1.52-2.31,3.86-3.58,4.78a41.42,41.42,0,0,1-3.85,2.28s0-2.82-4.48-3.4C87.76,73.48,77,82.8,77,82.8Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.59,152.38l28.52,116.37s20.54-1.14,26.25-8L104.69,153.52Z",
    fill: "#262626"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "117.68 155.42 117.68 118.15 81.04 118.15 81.04 155.42 100.46 155.65 117.68 155.42",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.04,
    y: 118.15,
    width: 36.64,
    height: 37.27,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "108.52 155.65 117.68 155.42 117.68 118.15 108.55 118.15 108.52 155.65",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 111.81,
    y: 118.15,
    width: 3.23,
    height: 6.47,
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6,147l-21.45-5.49-1.67-10.21L66.08,133l3,14.08c.65,2.89,3.36,4.15,6.25,4.69l24.3,3",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.79,154.33a38.05,38.05,0,0,1,9.29,3.39,5.19,5.19,0,0,0,1.54.9,53,53,0,0,0,5.13-1.63l2.12.73a.75.75,0,0,0,.88-.29c.18-.3.19-.74-.44-1.37-1.26-1.23-7.83-6-7.83-6s-1.63-2-.65-2.58,4.64-.89,4.11-2.72l-.15-.16-3.58.24-5.28,1.91-.94.72L99.44,147",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108,154.16a25.8,25.8,0,0,0,2.85,1.5c.8.4,1.53.74,2,1a3.71,3.71,0,0,0,.88.36",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.87,155.79a7.59,7.59,0,0,0,1.89,1.28,8.5,8.5,0,0,0,2.08,1",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.33,87.7s.16,3.51,1.46,5.25a1.83,1.83,0,0,1-2.33.45",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.68,88.29c.36,0,.65.51.65,1.15s-.27,1.16-.62,1.16-.64-.51-.65-1.15S95.33,88.3,95.68,88.29Z",
    fill: "#262626"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88,88.39c.35,0,.64.51.65,1.14s-.27,1.16-.62,1.17-.65-.51-.66-1.15S87.65,88.39,88,88.39Z",
    fill: "#262626"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M89.91,93.94c1.47,3.33,3.93,2.26,3.93,2.26",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.76,86.13a3.28,3.28,0,0,1,4,.27",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97.17,85.72a2.66,2.66,0,0,0-3.43.12",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "100.5 268.5 104.69 208.28 101.27 184.32",
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M125.36,19.22s14.87-4.57,20.82,12.36c0,0,11.44-5.95,18.76,2.06,0,0,10.52-1.61,14,4.8L86,36.61s1.14-13.27,12.35-14.19c0,0,10.53-17.84,27-3.2",
    fill: "#d7f5ea"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.31,50.65S41,47,44.83,60.6c0,0,7.43-4.79,12.19,1.66,0,0,6.83-1.29,9.06,3.87L5.75,64.65s.74-10.69,8-11.42c0,0,6.84-14.38,17.54-2.58",
    fill: "#d7f5ea"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33.39,
    y1: 283.2,
    x2: 315.19,
    y2: 283.2,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6,120.88l2.6,11.38s-7.14,3.52-11.7,1.24l-1-5",
    fill: "#00ffc7",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMercurioEmptyStateRecolecciones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mercurio_empty_state_recolecciones.397d7a0e.svg";
export { ForwardRef as ReactComponent };